export default "__VITE_ASSET__BScBcyE4__"